import "@fontsource/noto-sans-jp";
import "./src/styles/base.css";
import "./src/styles/blog-contents-style.css";
import '@fortawesome/fontawesome-free/css/all.min.css';

export const onRouteUpdate = () => {
  if (typeof window === "undefined") return;

  /* ------------------------------
   * フェード系
   * ------------------------------ */
  if ("IntersectionObserver" in window) {
    const elements = document.querySelectorAll(
      ".fadeInUp, .fadeInRight, .fadeInLeftToRight"
    );

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("on");
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1 }
    );

    elements.forEach((el) => observer.observe(el));
  }

  /* ------------------------------
   * キャッチコピー
   * ------------------------------ */
  requestAnimationFrame(() => {
    const mainText = document.querySelector(".mainVisual .text");
    if (mainText) mainText.classList.add("active");
  });

  /* ------------------------------
   * インタビュー Q&A
   * ------------------------------ */
  // const qaItems = document.querySelectorAll(
  //   ".recruitPage .interviewSec .qa-list dl"
  // );

  // qaItems.forEach((dl) => {
  //   if (dl.dataset.bind) return;
  //   dl.dataset.bind = "true";

  //   const dt = dl.querySelector("dt");
  //   const dd = dl.querySelector("dd");
  //   if (!dt || !dd) return;

  //   dt.addEventListener("click", () => {
  //     qaItems.forEach((item) => {
  //       const itemDd = item.querySelector("dd");
  //       if (item !== dl) {
  //         item.classList.remove("open");
  //         if (itemDd) itemDd.style.maxHeight = null;
  //       }
  //     });

  //     if (dl.classList.contains("open")) {
  //       dl.classList.remove("open");
  //       dd.style.maxHeight = null;
  //     } else {
  //       dl.classList.add("open");
  //       dd.style.maxHeight = dd.scrollHeight + "px";
  //     }
  //   });
  // });

  // /* ------------------------------
  //  * About画像ズーム
  //  * ------------------------------ */
  // const photoBox = document.querySelector(
  //   ".indexPage .aboutSec .inner .photoBox"
  // );
  // if (photoBox) {
  //   const img = photoBox.querySelector("img");
  //   if (img) {
  //     if ("IntersectionObserver" in window) {
  //       const zoomObserver = new IntersectionObserver(
  //         (entries) => {
  //           entries.forEach((entry) => {
  //             if (entry.isIntersecting) {
  //               img.classList.add("is-zoom");
  //               zoomObserver.unobserve(entry.target);
  //             }
  //           });
  //         },
  //         { threshold: 0.3 }
  //       );
  //       zoomObserver.observe(img); // img を監視
  //     } else {
  //       img.classList.add("is-zoom");
  //     }
  //   }
  // }
};




export const onInitialClientRender = () => {
  document.documentElement.classList.add("js");
  if (document.body) {
    document.body.classList.add("indexPage");
  }
};
